import React from "react";
import EnhanceWysiwyg from "../EnhanceWysiwyg";
import shortcodes from "./shortcodes";
import transforms from "./transforms";

const Text = ({ children }) => <div className="wysiwyg">{children}</div>;

export default EnhanceWysiwyg({
  shortcodes,
  transforms,
})(Text);
